export default {
  bookExperiencePanel: 'Elämyksen varauspaneeli',
  calendarIcon: 'Kalenterikuvake',
  coverImageForResource: 'Kansikuva elämyksille {{title}}',
  filterBy: 'Suodata: {{filter}}',
  filterByDateRange: 'Suodata päivämäärävälin mukaan',
  gallery: 'Galleria',
  goBack: 'Takaisin edelliselle sivulle',
  hostUserIcon: 'isännän käyttäjäkuvake',
  imageOf: 'Kuva kohteesta {{title}}',
  interactiveMapAltText:
    'Interaktiivinen kartta valittavilla kohteilla {{title}}',
  mediaSlides: 'Mediakuvat',
  muteVideo: 'Mykistä video',
  nextPhoto: 'Seuraava kuva',
  noVideoPlayback: 'Videota ei voi toistaa',
  pauseVideo: 'Keskeytä video',
  photoOf: 'kuva henkilöstä {{name}}',
  playVideo: 'Toista video',
  previousPhoto: 'Edellinen kuva',
  moreFiltersAndExperiences: 'Lisää suodattimia ja elämyksiä',
  reserveSelectedSlot: 'Varaa valittu aika',
  reviewRating: 'Arvostelun arvosana {{rating}} / 5',
  overallReviewRating: 'Kokonaisarvosana {{rating}} / 5',
  selectCountryCodeForPhoneNumber: 'Valitse puhelinnumeron maakoodi',
  selectDate: 'Valitse päivämäärä',
  selectParticipants: 'Valitse osallistujat',
  selectSessionTime: 'Valitse istunnon aika',
  unmuteVideo: 'Poista videon mykistys',
  viewShoppingCart: 'Näytä ostoskori',
  itemsInCart: '{{count}} tuotetta ostoskorissa',
  zoomIn: 'Lähennä',
  zoomOut: 'Loitonna',
  selectData: `Valitse {{data}}`,
  reserveName: `Varaa {{name}}`,
  deleteReservation: 'Poista {{experienceTitle}} varaus',
  editParticipantsFor: 'Muokkaa osallistujia kohteelle {{experienceTitle}}',
  enterPromoCode: 'Syötä tarjouskoodi',
  applyPromoCode: 'Käytä tarjouskoodi',
  increaseAddOnAmount: 'Lisää valittua {{addOn}}',
  decreaseAddOnAmount: 'Vähennä valittua {{addOn}}',
  addOnModal: '{{addOn}} -ikkuna',
  moreInformationAboutAddOn: 'Lisätietoja kohteesta {{addOn}}',
  decreasePriceTierTickets: 'Vähennä {{priceTier}} -lippuja',
  increasePriceTierTickets: 'Lisää {{priceTier}} -lippuja',
  downloadFilename: 'Lataa {{filename}}',
  viewFullDetailsDescription: 'Näytä täydelliset tiedot',
  viewFullDescription: 'Näytä koko kuvaus',
  closeModal: 'Sulje ikkuna',
  hyattBanner: 'World Of Hyatt -jäsenten eksklusiivinen banneri',
  hyattBannerDesc:
    'Mainospalkki, joka ilmaisee World of Hyatt -kanta-asiakasohjelman jäsenille saatavilla olevat eksklusiiviset edut ja tarjoukset',
  previousSlide: 'Edellinen dia',
  nextSlide: 'Seuraava dia',
  paginationBulletMessage: 'Siirry diaan',
  exitFullscreen: 'Poistu koko näytön tilasta',
  enterFullscreen: 'Siirry koko näytön tilaan',
  videoSlide: 'Videodia',
  imageSlide: 'Kuvadia',
  of: '/',
  noDescription: 'Ei kuvausta',
  mediaGallery: 'Karuselli - Mediagalleria',
  dateSelector: 'Päivämäärän valitsin',
  nextWeek: 'Seuraava viikko',
  previousWeek: 'Edellinen viikko',
  scheduleAgenda: 'Aikataulun ohjelma',
  scheduleNav: 'Aikataulun navigointi',
  scheduleViewSelector: 'Aikataulun näkymän valitsin',
  selectedDateAriaLabel: '{{date}}, valittu',
  tapToBookExperience: 'Varaa {{title}}',
  bookExperienceAriaLabel: 'Varaa {{title}}',
  joinWaitlistAriaLabel: 'Liity {{title}} jonotuslistalle',
};
